// import * as types from './types'
// import storage from '@/plugins/storage'
export default {
  isOpen: false,
  openingHours: [],
  tenantDetails: ''
}



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/state.js